const checkIsSupervisor = (supervisorsPositions: string[], position = "") => {
	return supervisorsPositions.includes(position);
};

export default checkIsSupervisor;
